<!-- eslint-disable -->

<template>
  <div>
    <div v-if="loading" class="pb-2">
      <span>Your quote data is loading, please wait...</span>
      <span class="ml-2 loading-spinner"></span>
    </div>

    <div
      v-if="quoteIsDeleted"
      class="w-full"
      id="deletedStamp"
    >
      <div class="deleted-label"> Deleted </div>
    </div>

    <form class="grid" @submit.prevent>
      <fieldset class="md:col-5 grid grid-align-override">
        <FormLabel :text="useShipTo ? 'Ship To' : 'Well Name'" class="xl:col-10 lg:col-9 md:col-12 col-12 pr-0 ship-to-input">
          <AutoComplete
            v-model="advancedSearch.wellAddressSearch.customerSearch"
            class="well-search-box w-full"
            :class="{ 'p-invalid': showWellNameShipToInvalid }"
            option-value="customer.id"
            :required="true"
            :suggestions="filteredWellAddressOptions"
            append-to="self"
            :placeholder="'Search by Well Name, Ship To, Address, API, UWI, or SAP ID'"
            :loading="fetchingShipTos || fetchingWellAddresses"
            :disabled="quoteIsWonOrRejected || loading"
            data-cy="well-search"
            @complete="completeSearchWell"
            @item-select="selectWellAddress"
            @blur="resetSearchWell"
          >
            <template #option="slotProps">
              <div v-if="slotProps.option?.well?.id">
                <div>
                  <b>{{ slotProps.option?.well?.name }}</b> ({{
                    slotProps?.option?.well?.uwi
                  }})
                </div>
              </div>

              <div v-else>
                <div>
                  <b>{{ slotProps.option?.address?.name }}</b> ({{
                    slotProps.option?.address?.id
                  }})
                </div>
                <div>{{ slotProps.option?.address?.full_address }}</div>
              </div>
            </template>
            <template #loader>
              <div>loading...</div>
            </template>
          </AutoComplete>
        </FormLabel>
        <!-- NOTE: the ship-to-checkbox css might need a rework when doing breakpoints -->
        <FormLabel
class="xl:col-2 lg:col-3 md:col-5 col-2 ship-to-box p-disabled"
          text="Non-Well"
        >
          <Checkbox
            v-model="useShipTo"
            inputId="displayFilter"
            class="ship-to-checkbox"
            :binary="true"
:disabled="true"
            data-cy="well-search-checkbox"
          />
        </FormLabel>
        <div class="col-12 md:col-12 lg:col-12 xl:col-5 lg:mr-5">
          <div data-cy="well-search-info-label"
            class="pb-1" style="font-weight: bold;"
          >
            {{ useShipTo ? 'WELL NAME' : 'SHIP TO' }}
          </div>
          <div data-cy="well-search-info-value">{{ getWellOrAddressLabel() }}</div>
        </div>
        <!-- TODO: Solve problem with height -->
        <div class="col" style="height: 67.48px;">
          <b>STATE/REGION</b>
          <br>
          {{ advancedSearch.wellAddressSearch.address.region.code }}
        </div>
        <div class="col" style="height: 67.48px;">
          <b>COUNTRY</b>
          <br>
          {{ advancedSearch.wellAddressSearch.address.region.country.code }}
        </div>
        <FormLabel text="QUOTE NAME" class="col-12">
          <InputText
            v-model="advancedSearch.quoteSearch"
            class="quote-name-autocomplete w-full"
            :class="{ 'p-invalid': showQuoteNameInvalid }"
            :suggestions="[]"
            placeholder="e.g. Mimbo 419 B Unit SH Quote 1"
            :disabled="quoteIsWonOrRejected || loading"
            @keyup="quoteNameOnKeyUp"
          >
          </InputText>
        </FormLabel>

        <FormLabel text="Job Type" class="col-6" v-tooltip.top="jobTypeDisabledReason">
          <Dropdown
            v-model="sgqJobType"
            class="w-full"
            :class="{ 'p-invalid': showJobTypeInvalid }"
            :options="filteredJobTypes"
            :dropdown="true"
            placeholder="Select Job Type"
            append-to="self"
            option-label="comment"
            option-value="value"
            :disabled="quoteIsWonOrRejected || loading || !pricingDataComplete"
            @change="processServiceCharges()"
          />
        </FormLabel>
        <FormLabel text="Quote Type" class="col-6" v-tooltip.top="jobTypeDisabledReason">
          <Dropdown
            v-model="sgqQuoteType"
            class="w-full"
            :class="{ 'p-invalid': showQuoteTypeInvalid }"
            :options="filteredQuoteTypes"
            :dropdown="true"
            placeholder="Select Quote Type"
            append-to="self"
            option-label="comment"
            option-value="value"
            :disabled="quoteIsWonOrRejected || loading || !pricingDataComplete"
            @change="processServiceCharges()"
          />
        </FormLabel>
        <ScenarioAutocomplete
          :refetchQuote="props.refetchQuote"
          :quote="quote"
          :advancedSearch="advancedSearch"
          :disabled="quoteIsWonOrRejected"
          @toggle="toggleSaving"
        />
        <div class="job-row-wrap">
          <FormLabel
            v-if="advancedSearch.skPlanningOrder"
            text="Planning Order Number"
            class="col-3 w-auto"
          >
            <InputText class="w-full uniform-height" :value="advancedSearch.skPlanningOrder" :disabled="true" />
          </FormLabel>
          <FormLabel
            text="Job Number"
            class="col-3 w-auto pr-5 mr-3"
          >
            <InputText
              data-cy="job-number-input"
              :class="(advancedSearch.sk_job_id ? 'job-number-input' : 'p-disabled')"
              :value="advancedSearch.sk_job_number"
              :disabled="!advancedSearch.sk_job_id"
              @click="openJob($event)"
              v-tooltip.top="advancedSearch.sk_job_number ? 'Click to open SK Job in a new tab' : ''"
              readonly
            />
          </FormLabel>
          <div class="button-group">
            <Button
              v-if="statuses && (advancedSearch.status === statuses.draft)"
              label="Delete Draft"
              class="delete-draft-button quote-button p-button-info uniform-height"
              @click="deleteDraftClicked"
            />
            <CopyQuoteLineItems
              :quote="quote"
              :loading="loading"
              class="uniform-height"
            />
            <UpdateLineItemPricing :quote="quote"
              :loading="loading"
              :quoteIsWonOrRejected="quoteIsWonOrRejected"
              class="uniform-height"
            />
          </div>
        </div>
      </fieldset>
      <div class="line-divider">&nbsp;</div>
      <fieldset class="col grid grid-align-override" :disabled="false">
        <FormLabel
          :text="contractLabelText"
          class="col-12 md:col-6 lg:col-6 xl:col-3"
        >
          <!-- TODO: breakout contract to own component (in general other components could as well) -->
          <AutoComplete
            v-model="advancedSearch.contractSearch.contractSearchString"
            class="w-full"
            :suggestions="filteredContracts"
            optionValue="number"
            optionLabel="number"
            :loading="fetchingContracts"
            :dropdown="true"
            :placeholder="
              advancedSearch.wellAddressSearch
                ? 'Search'
                : 'Select Well for contracts'
            "
            :disabled="
              quoteIsWonOrRejected ||
              !advancedSearch?.wellAddressSearch?.customer?.id
            "
            @complete="completeSearchContract"
            @item-select="selectContract"
            @blur="resetSearchContract"
          >
            <template #option="slotProps">
              <span class="contract-option-row">
                <span>{{ slotProps.option.number }}</span>
                <span
                  v-if="isContractExpired(slotProps.option)"
                  class="expired-badge"
                >
                  {{ isContractExpired(slotProps.option) ? 'Expired' : '' }}
                </span>
              </span>
            </template>
          </AutoComplete>
        </FormLabel>
        <FormLabel text="Price List" class="col-12 md:col-6 lg:col-6 xl:col-3">
          <AutoComplete
            v-model="advancedSearch.priceListSearch.priceListSearchString"
            class="w-full"
            :class="{ 'p-invalid': showPriceListInvalid }"
            :suggestions="filteredPriceLists"
            option-value="number"
            option-label="name"
            :loading="fetchingPriceLists"
            :dropdown="true"
            placeholder="Search"
            :disabled="quoteIsWonOrRejected || loading"
            @item-select="selectPriceList"
            @complete="completeSearchPriceList"
            @blur="resetPriceList"
          />
        </FormLabel>
        <FormLabel ref="nwaLabelElement" text="NWA" class="col-12 md:col-6 lg:col-6 xl:col-3">
          <AutoComplete
            v-model="advancedSearch.nwaSearch.nwaSearchString"
            class="w-full"
            :class="{ 'p-invalid': showNwaInvalid }"
            :suggestions="filteredNwas"
            option-value="id"
            :option-label="getNwaOptionLabel"
            :dropdown="true"
            :loading="fetchingNwas"
            placeholder="Search"
            :disabled="quoteIsWonOrRejected || loading"
            @item-select="selectNwaSearch"
            @complete="completeSearchNwa"
            @blur="resetSearchNwa"
          />
        </FormLabel>
        <FormLabel text="Sales District" class="col-12 md:col-6 lg:col-6 xl:col-3">
          <!-- Plant Auto complete -->
          <AutoComplete
            v-model="advancedSearch.salesDistrictSearch.plantSearch"
            class="w-full"
            :class="{ 'p-invalid': showSalesDistrictInvalid }"
            option-label="name"
            option-value="name"
            :required="true"
            :suggestions="filteredPlants"
            :dropdown="true"
            :loading="fetchingPlants"
            append-to="self"
            placeholder="Search"
            :disabled="quoteIsWonOrRejected || loading"
            @complete="completeSearchPlant"
            @item-select="selectSearchPlant"
            @blur="resetSearchPlant"
          />
        </FormLabel>
        <FormLabel
          text="Proposed Start Date"
          class="col-12 md:col-6 lg:col-6 xl:col-3"
          @keydown.enter="handleProposedStartDateCalendarBlur">
          <Calendar
            ref="proposedStartDateCalendarRef"
            v-model="advancedSearch.proposedStartDate"
            date-format="mm/dd/yy"
            class="w-full"
            :class="{ 'p-invalid': showProposedStartDateInvalid }"
            :manual-input="true"
            show-icon
            show-button-bar
            :disabled="quoteIsWonOrRejected || loading"
          />
        </FormLabel>
        <FormLabel
          text="Pricing Date"
          class="col-12 md:col-6 lg:col-6 xl:col-3"
          @keydown.enter="handlePricingDateCalendarBlur">
            <Calendar
              ref="pricingDateCalendarRef"
              v-model="advancedSearch.pricingDate"
              date-format="mm/dd/yy"
              class="w-full"
              :class="{ 'p-invalid': showPricingDateInvalid }"
              :manual-input="true"
              show-icon
              show-button-bar
              :disabled="quoteIsWonOrRejected || loading"
              @date-select="updatePricing"
            />
        </FormLabel>
        <FormLabel text="Account Manager" class="col-12 md:col-6 lg:col-6 xl:col-3">
          <!-- Default to current user -->
          <AutoComplete
            v-model="advancedSearch.userSearch.userSearchString"
            class="w-full"
            :class="{ 'p-invalid': showPreparedByInvalid }"
            :suggestions="filteredUsers"
            option-value="id"
            option-label="display_name"
            :value="user.id"
            :dropdown="true"
            placeholder="Search"
            :disabled="quoteIsWonOrRejected || loading"
            @complete="completeSearchUser"
            @item-select="selectUserSearch"
            @blur="resetUserSearch"
          />
        </FormLabel>
        <FormLabel text="Proposal" class="col-12 md:col-6 lg:col-6 xl:col-3">
          <InputText
            v-model="advancedSearch.skProposalNumber"
            class="w-full"
            :useGrouping="false"
            :dropdown="true"
            placeholder="Proposal Number"
            :disabled="true"
          />
        </FormLabel>
        <FormLabel text="Currency" class="col-12 md:col-6 lg:col-6 xl:col-3">
          <AutoComplete
            v-model="advancedSearch.currency.currencySearchString"
            class="w-full"
            :class="{ 'p-invalid': showCurrencyInvalid }"
            :suggestions="filteredCurrencies"
            option-label="code"
            option-value="code"
            :dropdown="true"
            placeholder="Search"
            :loading="fetchingCurrencies"
            :disabled="quoteIsWonOrRejected || loading"
            @complete="completeSearchCurrency"
            @item-select="currencySelect"
            @blur="resetSearchCurrency"
          />
        </FormLabel>


        <!-- temp elements for spacing reasons: -->
        <!-- NOTE: the temp elements will be removed when the UI is redesigned -->
        <!-- <FormLabel text="" class="col-9 no-select-cursor">
          <InputText
            style="visibility: hidden;"
            :disabled="true"
            class="w-full no-select-cursor"
            v-model="advancedSearch.repPhone"
          >
          </InputText>
        </FormLabel>
        -->


        <FormLabel text="Out Rep Name" class="col-12 md:col-6 lg:col-6 xl:col-3">
          <InputText
            :disabled="quoteIsWonOrRejected || loading"
            class="w-full"
            v-model="advancedSearch.repName"
          >
          </InputText>
        </FormLabel>
        <FormLabel text="Out Rep Email" class="col-12 md:col-6 lg:col-6 xl:col-3">
          <InputText
            :disabled="quoteIsWonOrRejected || loading"
            class="w-full"
            v-model="advancedSearch.repEmail"
          >
          </InputText>
        </FormLabel>
        <FormLabel text="Out Rep Phone" class="col-12 md:col-6 lg:col-6 xl:col-3">
          <InputText
            v-model="advancedSearch.repPhone"
            @keydown="checkValidPhoneInput"
            @paste="checkValidPhoneInput"
            :disabled="quoteIsWonOrRejected || loading"
            class="w-full"
          >
          </InputText>
        </FormLabel>
      </fieldset>

      <fieldset class="col-12 internal-notes-field">
        <FormLabel class="internal-notes-label" text="INTERNAL NOTES">
          <Textarea
            :disabled="quoteIsWonOrRejected || loading"
            class="internal-notes-box"
            rows="4"
            autoResize
            v-model="advancedSearch.note"
          />
        </FormLabel>
      </fieldset>
    </form>
  </div>
</template>
<script lang="ts" setup>
/* eslint-disable */

import {
  ref,
  reactive,
  computed,
  watch,
  toRefs,
  onMounted,
  nextTick,
  toRaw
} from "vue";
import type { PropType } from "vue";
import { useRoute, useRouter } from "vue-router";
import type {
  SkPriceList,
  SkNwa,
  SkPlant,
  SkContract,
  SkWellAddress,
  UsersFieldsFragment,
  SkCurrency,
  SkMaterial,
  SkMaterialsQuery
} from "gql/api";
import {
  AllQuoteFieldsFragment as QuoteType,
  QuoteLineItemFieldsFragment as QuoteLineItemType,
  Quote_Line_Item_Type_Dataset_Enum as LineItemType,
  Quote_Line_Item_Category_Dataset_Enum as Category,
  Quote_Line_Item_Subcategory_Dataset_Enum as SubCategory,
  Quote_Line_Item_Source_Dataset_Enum as Source,
  Quote_Sk_Job_Type_Dataset_Enum as SKJobType,
  useUpdateQuoteByPkMutation,
  useUpdateManyQuoteLineItemsMutation,
  useSkPriceListsQuery,
  useGetSkNwasQuery,
  useGetSkCurrenciesQuery,
  useSkPlantsQuery,
  useSkContractsQuery,
  useSkWellAddressesQuery,
  useUsersQuery,
  useGetQuoteSkJobTypeDatasetQuery,
  useGetSkPlanningOrderQuery,
  useSkMaterialsQuery,
  useSkJobsQuery,
  Users_Select_Column
} from "gql/api";
import InputText from "primevue/inputtext";
import Textarea from 'primevue/textarea';
import Calendar from "primevue/calendar";
import AutoComplete, {
  AutoCompleteCompleteEvent,
  AutoCompleteItemSelectEvent
} from "primevue/autocomplete";
import UpdateLineItemPricing from "@/components/quotes/UpdateLineItemPricing.vue";
import FormLabel from "@/components/FormLabel.vue";
import type {
  QuotesSearch,
  NwaSearchParams,
  PlantSearchParams,
  ContractSearchParams,
  WellAddressSearchParams,
  PriceListSearchParams,
  CurrencySearchParams,
  JobSearchParams,
  MaterialQueryParams,
  CanBeMissing,
  GqlQli
} from "@/components/quotes/types";
import type { SpyglassUser } from "@/composables/auth/useUserInfo";
import { useToast } from "primevue/usetoast";

import {
  JobTypeServiceMaterialNumbers,
  JobTypeServiceMaterialShortDesc,
  JobTypeServiceMaterialLongDesc,
  createQueryString,
  autoVal,
  fixDate,
  statuses,
  checkValidPhoneInput,
  parentOrder,
  getAddedMaterialSubOrder,
  formatQuoteHeaderForSave,
  formatQuoteLineItemForSave,
  getSpyGlassDate,
  cleanNull,
  SgqJobTypes,
  SgqQuoteTypes,
  buildQuotePlanningOrderQueryString,
  getNwaDisplayName,
  getNwaOptionLabel,
  getQuoteNwaFields,
  getQuotePricingContext,
  pickQuotePlanningOrder,
} from "@/utils/quoteHelpers";
import { useCanonicalNwaLookup } from "@/composables/quote/useCanonicalNwaLookup";
import ScenarioAutocomplete from "@/components/quotes/ScenarioAutocomplete.vue";
import CopyQuoteLineItems from "@/components/quotes/CopyQuoteLineItems.vue";
import { resolveContractSearchTerm } from "@/components/quotes/contractSearch";
import useUserInfo from "@/composables/auth/useUserInfo";

const user = useUserInfo() as SpyglassUser;

const router = useRouter();
const route = useRoute();
const toast = useToast();
const quoteId = router.currentRoute?.value?.params?.quoteId;

const emit = defineEmits([
  "toggle", // side panel toggle
  "run-fetch-materials" // refetch mats in side panel when contract selected
]);
// TODO: autosave (saveQuote) is critical for sk job type, but should be omitted
const props = defineProps({
  quote: {
    type: Object as PropType<QuoteType | null>,
    default: null
  },
  sidePanelOpen: {
    type: Boolean,
    default: false
  },
  advancedSearch: {
    type: Object as PropType<QuotesSearch>,
    default: null
  },
  saveQuote: {
    type: Function,
    required: true
  },
  refetchQuote: {
    type: Function,
    required: true,
  },
  isMissingRequiredMaterialData: {
    type: Boolean,
    default: false,
    required: true
  }
});

const getWellOrAddressLabel = () => {
  const well = advancedSearch.value?.wellAddressSearch?.well;
  const address = advancedSearch.value?.wellAddressSearch?.address;
  const customer = advancedSearch.value?.wellAddressSearch?.customer;
  const customerSearch = advancedSearch.value?.wellAddressSearch?.customerSearch;

  const wellName = well?.name && well?.id
    ? `${well.name} (${well.id})`
    : '';

  const shipToAddress = address?.name && address?.id
    ? `${address.name} ${address?.full_address || ''} (${address.id})`.trim()
    : '';

  const shipToCustomer = customer?.name && customer?.id
    ? `${customer.name} (${customer.id})`
    : customer?.name || customerSearch || '';

  if (!wellName && !shipToAddress && !shipToCustomer) {
    return '';
  }

  // If searching by ship to, show well details when available, else fallback to ship to.
  // If searching by well, show ship to details when available, else fallback to well.
  if (useShipTo.value) {
    return wellName || shipToAddress || shipToCustomer;
  }

  return shipToAddress || wellName || shipToCustomer;
}

// REFS:
const loading = ref<boolean>(false); // TODO: not needed anymore?
const quoteIsDeleted = computed(() => {
  return Boolean(quote?.value?.deleted_at);
});
const proposedStartDateCalendarRef = ref<InstanceType<typeof Calendar> | null>(null);
const pricingDateCalendarRef = ref<InstanceType<typeof Calendar> | null>(null);
const contractLabelText = ref<string>("Contract");
const sgqJobType = ref<string>("")
const sgqQuoteType = ref<string>("")

// TOREFS: (Required to preserve the prop's reactivity)
const { quote, sidePanelOpen, advancedSearch, isMissingRequiredMaterialData } = toRefs(props);

const saveClicked = ref<boolean>(false);
const showQuoteNameInvalid = computed(() => {
  return (
    !advancedSearch.value?.quoteSearch ||
    advancedSearch.value?.quoteSearch === ""
  );
});

const showWellNameShipToInvalid = computed(() => {
  return (
    quote?.value?.id &&
    !advancedSearch?.value?.wellAddressSearch?.customerSearch
  );
});

const showPriceListInvalid = computed(() => {
  return (
    quote?.value?.id &&
    !advancedSearch?.value?.priceListSearch?.priceListSearchString
  );
});

const showJobTypeInvalid = computed(() => {
  return quote?.value?.id && !sgqJobType.value;
});

const showQuoteTypeInvalid = computed(() => {
  return quote?.value?.id && !sgqQuoteType.value;
});

const showNwaInvalid = computed(() => {
  return quote?.value?.id && !advancedSearch?.value?.nwaSearch?.nwaSearchString;
});

const showProposedStartDateInvalid = computed(() => {
  return quote?.value?.id && !advancedSearch?.value?.proposedStartDate;
});

const showSalesDistrictInvalid = computed(() => {
  return (
    quote?.value?.id && !advancedSearch?.value?.salesDistrictSearch?.plantSearch
  );
});

const showPricingDateInvalid = computed(() => {
  return quote?.value?.id && !advancedSearch?.value?.pricingDate;
});

const showCurrencyInvalid = computed(() => {
  return (
    quote?.value?.id && !advancedSearch?.value?.currency?.currencySearchString
  );
});

const showPreparedByInvalid = computed(() => {
  return (
    quote?.value?.id && !advancedSearch?.value?.userSearch?.userSearchString
  );
});

const quoteIsWonOrRejected = computed(() => {
  return [statuses.won, statuses.rejected].some(
    status => status === quote?.value?.status
  );
});

// Quote Data Fetching
const filteredQuotes = ref<Array<any>>([]);
const quoteNameOnKeyUp = () => {
  // if typing in quote name, reset save clicked for errors
  saveClicked.value = false;
};

// NWA Data Fetching
const filteredNwas = ref<Array<SkNwa>>([]);
const { executeQuery: fetchNwas, fetching: fetchingNwas } = useGetSkNwasQuery({
  pause: true,
  requestPolicy: "network-only",
  variables: computed(() => {
    const queryParams: NwaSearchParams = {
      active: "True",
      deleted: "False",
      name__icontains: advancedSearch.value.nwaSearch.nwaSearchString,
      ordering: "name",
      expand: "country",
    };

    return {
      summitQueryString: createQueryString(queryParams)
    };
  })
});

const selectNwaSearch = () => {
  const searchVal = advancedSearch.value.nwaSearch.nwaSearchString;
  // Show the AL Name (original ECC name) when ERP has one; the id is what
  // is stored and sent to SK.
  const displayName = getNwaDisplayName(searchVal);
  advancedSearch.value.nwaSearch.name = displayName;
  advancedSearch.value.nwaSearch.id = searchVal.id;
  advancedSearch.value.nwaSearch.nwaSearchString = displayName;
  if (!advancedSearch?.value?.wellAddressSearch?.address?.region?.country?.code) {
    advancedSearch.value.wellAddressSearch.address.region.country.code = searchVal?.country?.code;
  }
};

const completeSearchNwa = () => {
  return Promise.resolve()
    .then(() => fetchNwas())
    .then(resp => {
      filteredNwas.value = cleanNull(resp.data.value?.getSKNwas || []);
    });
};

const resetSearchNwa = () => {
  advancedSearch.value.nwaSearch.nwaSearchString =
    advancedSearch.value.nwaSearch.name || ""; // <--- prevents undefined as string
};

// Quotes store the NWA name from when they were saved, often a retired ECC
// name. Refresh the displayed name from the canonical NWA by id; it is saved
// with the next header save. The id is never changed here.
const { resolveNwa } = useCanonicalNwaLookup();
const nwaDisplayNames = new Map<string, string>();
const refreshNwaDisplayName = async () => {
  const nwaId = advancedSearch.value?.nwaSearch?.id;
  if (!nwaId) {
    return;
  }
  const key = String(nwaId);
  if (!nwaDisplayNames.has(key)) {
    const resolution = await resolveNwa(nwaId);
    // Only rename once ERP serves `display_name` (AL Name support), so users
    // keep the familiar ECC name until AL Names are available.
    if (!resolution.looked_up || !resolution.nwa?.display_name) {
      return;
    }
    nwaDisplayNames.set(key, getNwaDisplayName(resolution.nwa));
  }
  const displayName = nwaDisplayNames.get(key);
  const nwaSearch = advancedSearch.value?.nwaSearch;
  if (displayName && String(nwaSearch?.id) === key && nwaSearch.name !== displayName) {
    nwaSearch.name = displayName;
    nwaSearch.nwaSearchString = displayName;
  }
};
watch(
  () => [advancedSearch.value?.nwaSearch?.id, advancedSearch.value?.nwaSearch?.name],
  () => { refreshNwaDisplayName(); },
  { immediate: true }
);

const { executeMutation: updateQuote } =
  useUpdateQuoteByPkMutation();
const { executeMutation: updateManyQuoteLineItems } =
  useUpdateManyQuoteLineItemsMutation();
const { executeQuery: fetchMaterials, fetching: fetchingMaterials } =
  useSkMaterialsQuery({
    pause: true,
    requestPolicy: "network-only",
    variables: computed(() => {
      const q = quote.value;
      const queryParams: MaterialQueryParams = {
        country:
          advancedSearch?.value?.wellAddressSearch?.address?.region?.country
            ?.code,
        deleted: "False",
        exclude_trade_in: "True",
        expand: "pricing",
        ordering: "description,number",
        number__in: cleanNull(
          (q?.quote_line_items || []).map((qli) => qli?.erp_material_number)
            .filter(number => number && number !== "custom")
        ),
        price_list: advancedSearch?.value?.priceListSearch?.number,
        // @todo update contract search to be an object
        pricing_date: fixDate(advancedSearch?.value?.pricingDate)
      };

      if (advancedSearch?.value?.contractSearch?.number) {
        queryParams.contract = advancedSearch?.value?.contractSearch?.number;
      }

      return {
        summitQueryString: createQueryString(queryParams)
      };
    })
  });

/**
 * Update the pricing for quote line items.
 * Use for updating from the raw API response.
 *
 * @returns SkMaterials[] | Promise<void>
 * Optionally return the materials from the response if you want it.
 */
const updatePricing = async () => {
  // Parent validation and query variables must reflect the newly selected header.
  await nextTick();
  const hasQuoteLineItems = quote?.value?.quote_line_items?.some(
    item => item.erp_material_number && item.erp_material_number !== "custom"
  );

  if (hasQuoteLineItems && !isMissingRequiredMaterialData.value) {
    return fetchMaterials()
      .then(resp => {
        const materials = cleanNull(resp?.data?.value?.getSKMaterials || []);
        const quoteLineItems: QuoteLineItemType[] = quote?.value?.quote_line_items || [];

        quoteLineItems.forEach(item => {
          const material = materials.find(
            m => m.number === item.erp_material_number
          );
          if (material) {
            item.erp_price = material?.pricing?.price || 0;
          }
        });

        // TODO: updating computed directly, not ideal from vue's recommendations. Investigating.
        quote!.value!.quote_line_items = quoteLineItems;
        return resp;
      });
  }
};

// Plant (Sales District) Data Fetching
const filteredPlants = ref<Array<SkPlant>>([]);
const { executeQuery: fetchPlants, fetching: fetchingPlants } =
  useSkPlantsQuery({
    pause: true,
    requestPolicy: "network-only",
    variables: computed(() => {
      const queryParams: PlantSearchParams = {
        is_active: "True",
        deleted: "False",
        group_not_in: "web-service",
        page_size: "30",
        search: advancedSearch.value.salesDistrictSearch.plantSearch
      };

      return {
        summitQueryString: createQueryString(queryParams)
      };
    })
  });

const selectSearchPlant = () => {
  const searchVal = advancedSearch.value.salesDistrictSearch.plantSearch;
  advancedSearch.value.salesDistrictSearch.name = searchVal.name;
  advancedSearch.value.salesDistrictSearch.id = searchVal.id;
  advancedSearch.value.salesDistrictSearch.plantSearch = searchVal.name;
};

const completeSearchPlant = () => {
  return Promise.resolve()
    .then(() => fetchPlants())
    .then(resp => {
      filteredPlants.value = cleanNull(resp?.data?.value?.getSKPlants || []);
    });
};

const resetSearchPlant = () => {
  advancedSearch.value.salesDistrictSearch.plantSearch =
    advancedSearch.value.salesDistrictSearch.name || ""; // <--- prevents undefined as string
};

const { executeQuery: fetchPlanningOrder } = useGetSkPlanningOrderQuery({
  pause: true,
  requestPolicy: "network-only",
  variables: computed(() => {
    const wellAddressSearch = advancedSearch.value.wellAddressSearch;
    // Omit empty well_id/address_id: SK treats a present-but-empty key as a
    // filter for blank values, which hid planning orders for well-only and
    // ship-to-only selections (users had to re-save the ship-to).
    const queryString = buildQuotePlanningOrderQueryString({
      addressId: wellAddressSearch?.address?.id,
      customerId: wellAddressSearch?.customer?.id,
      wellId: wellAddressSearch?.well?.id
    });

    // Without a customer and well/address, force 0 results from SK with 200 OK.
    return {
      summitQueryString: queryString || createQueryString({ customer_id: "", well_id: "" })
    };
  })
});

// Contract Data Fetching
const filteredContracts = ref<Array<SkContract>>([]);
const contractSearchTerm = ref("");
const { executeQuery: fetchContracts, fetching: fetchingContracts } =
  useSkContractsQuery({
    pause: true,
    requestPolicy: "network-only",
    variables: computed(() => {
      const queryParams: ContractSearchParams = {
        expand: "price_list",
        ordering: "number",
        number__icontains: contractSearchTerm.value,
        active: "True",
        deleted: "False",
        page_size: "all",
      };

      if (advancedSearch?.value?.wellAddressSearch?.customer?.id) {
        queryParams.customer =
          advancedSearch?.value?.wellAddressSearch?.customer?.id;
      }

      return {
        summitQueryString: createQueryString(queryParams)
      };
    })
  });

const completeSearchContract = (event?: AutoCompleteCompleteEvent) => {
  contractSearchTerm.value = resolveContractSearchTerm(
    advancedSearch.value?.contractSearch,
    event?.query
  );

  return Promise.resolve()
    .then(() => fetchContracts())
    .then(resp => {
      // TODO: investigate issues with contracts
      const contracts = cleanNull(resp?.data?.value?.getSKContracts || []);
      // Filter expired contracts and match search string
      const searchStr = isNaN(advancedSearch.value.contractSearch.contractSearchString)
        ? advancedSearch.value.contractSearch.contractSearchString?.toLowerCase() || ''
        : String(advancedSearch.value.contractSearch.contractSearchString).toLowerCase();
        // ^ TODO: types keep flickering from Number to String. Resolving soon.

      // Show all contracts that match the search string
      // TODO: default backend behavior doesn't filter based on search string
      // regardless if expired, so implemented on frontend
      filteredContracts.value = contracts.filter(contract => {
        const matchesSearch = contract.number?.toLowerCase();
        return matchesSearch;
      });
    });
};

// Add this near other query declarations (around line 430)
const materialQueryParamsTwo = ref<MaterialQueryParams | null>(null);
const { executeQuery: fetchMaterialsCountryOnly } =
  useSkMaterialsQuery({
    pause: true,
    requestPolicy: "network-only",
    variables: computed(() => {
      if (!materialQueryParamsTwo.value) return { summitQueryString: "" };
      return {
        summitQueryString: createQueryString(materialQueryParamsTwo.value)
      };
    })
  });

const selectContract = (event: Partial<AutoCompleteItemSelectEvent>) => {
  const isNewContractSelected = advancedSearch.value.contractSearch.number !== event.value.number;
  const hasQlisToUpdate = quote?.value?.quote_line_items?.length;
  const shouldUpdatePricing = isNewContractSelected && hasQlisToUpdate;

  advancedSearch.value.contractSearch.number = event.value.number;
  advancedSearch.value.contractSearch.contractSearchString = event.value.number;

  if (quote?.value?.id) {
    // TODO: other select functions don't assign the quote value directly like this, investigating
    quote.value.erp_contract_number = event.value.number;
  }

  const contract = filteredContracts.value.find(contract => contract.number === event.value.number);
  if (contract) {
    const isExpired = isContractExpired(contract);
    contractLabelText.value = `Contract ${ isExpired ? '🔴 Expired' : '' }`

    if (isExpired) {
      toastContractExpiredWarn(contract);
    }
  }

    /** (Step 1/2)
   * Refetch+update prices in the material side panel.
   *
   * The materials and prices in the material side panel are
   * based on slightly different constraints than this file's
   * update function, so run them both.
  */
  nextTick().then(() => {
    emit("run-fetch-materials");  // <--- refresh prices in material side panel
  });

  if (shouldUpdatePricing) {
    /** (Step 2/2)
     *
     * Update the prices on the quote design list.
     *
     * Optimal to run this in parallel to the side panel refetch.
     * We don't need to wait for its response.
     */
    toast.add({
      severity: "info",
      summary: "Updating prices",
      detail: "Updating prices based on selected contract, please wait...",
      life: 3000
    });
    updatePricing().then((resp) => {
      /**
       * Per request of Michael Erison:
       * "if item is NOT ON the contract, default to country-level pricing."
       *
       * Note for devs: difference between NOT FOUND and FOUND AT $0:
       * - NOT FOUND = SK returned null on the pricing field
       * - FOUND AT $0 = SK returned the expanded pricing field with an explicit price of $0.
       */
      const materialsFromContract = cleanNull(resp?.data?.value?.getSKMaterials || []);
      const materialsWithPricesNotFound = cleanNull(materialsFromContract)
        .filter((m: SkMaterial) => m && m?.pricing === null)
        .map((m: SkMaterial) => m && m?.number)
        .filter((mn): mn is string => Boolean(mn));

      if (materialsWithPricesNotFound.length && !isMissingRequiredMaterialData.value) {
        // Construct the query with dynamic list of materials not found on contract
        // TODO: could probably just make this reactive...a lot of commonality with the first query
        materialQueryParamsTwo.value = {
          country: advancedSearch?.value?.wellAddressSearch?.address?.region?.country?.code,
          deleted: "False",
          exclude_trade_in: "True",
          expand: "pricing",
          ordering: "description,number",
          number__in: materialsWithPricesNotFound,
          price_list: advancedSearch?.value?.priceListSearch?.number,
          pricing_date: fixDate(advancedSearch?.value?.pricingDate)
        }

        // Then finally fetch and update
        return nextTick().then(() => {
          return fetchMaterialsCountryOnly().then(resp => {
            const countryMaterials: SkMaterial[] = cleanNull(resp?.data?.value?.getSKMaterials || []);
            const countryMaterialNumbers: string[] = countryMaterials
              .map((m: SkMaterial) => m.number)
              .filter((n): n is string => Boolean(n));
            const updateLineItems: QuoteLineItemType[] = (quote?.value?.quote_line_items || [])
              .filter((qli: QuoteLineItemType) =>
                qli.erp_material_number && countryMaterialNumbers.includes(qli.erp_material_number)
              )

            // Modify inline:
            if (updateLineItems) {
              updateLineItems.forEach((qli: QuoteLineItemType) => {
                const countryMaterial = countryMaterials.find((m: SkMaterial) => m.number === qli.erp_material_number);
                if (countryMaterial) {
                  qli.erp_price = countryMaterial?.pricing?.price || 0; // <--- the modification
                }
              });
            }
            return resp;
          })
        }).finally(() => {
          // Reset the material query params to prevent unintended consequences on other queries
          materialQueryParamsTwo.value = null;
        });
      }
    }).then(() => {
        toast.add({
          severity: "success",
          summary: "Prices updated",
          detail: "Please confirm then save!",
          life: 5000
        });
    }).catch((err) => {
      toast.add({
        severity: "warn",
        summary: "Error updating prices",
        detail: "Please confirm prices or contact support.",
        life: 5000
      });
      console.error("Error updating prices after selecting contract:", err);
      throw err;
    })
  }
};

const resetSearchContract = () => {
  advancedSearch.value.contractSearch.contractSearchString =
    advancedSearch.value.contractSearch.number || "";
}

const isContractExpired = (contract: SkContract) => {
  // Dev note: expiry info is stored on the response object (not quote or advanced search)
  // TODO: in another PR, add proper types to the advancedSearch object in EditQuote
  const contractRange = contract?.date_range;
  const quotePricingDate = advancedSearch.value?.pricingDate ? new Date(advancedSearch.value.pricingDate) : null;
  const cannotDetermineExpiry = !contractRange || !quotePricingDate;
  if (cannotDetermineExpiry) {
    return false; // Assume valid if can't determine
  }

  const contractLower = contractRange?.lower ? new Date(contractRange.lower) : null;
  const contractUpper = contractRange?.upper ? new Date(contractRange.upper) : null;
  const isQuotePricingDateBeforeContract = contractLower && quotePricingDate < contractLower;
  const isQuotePricingDateAfterContract = contractUpper && quotePricingDate > contractUpper;
  const isContractExpired = !!(isQuotePricingDateBeforeContract || isQuotePricingDateAfterContract);

  return isContractExpired;
};

const toastContractExpiredWarn = (contract: SkContract) => {
  // Dev note: expiry info is stored on the response object (not quote or advanced search)
  // TODO: in another PR, add proper types to the advancedSearch object in EditQuote
  const contractRange = contract?.date_range;
  const contractLower = contractRange?.lower ? new Date(contractRange?.lower) : '';
  const contractUpper = contractRange?.upper ? new Date(contractRange?.upper) : '';
  const quotePricingDate = advancedSearch.value?.pricingDate ? new Date(advancedSearch.value.pricingDate) : '';

  toast.add({
    severity: "warn",
    summary: "Selected contract is expired",
    detail: `Contract ${contract.number} is valid from ${getSpyGlassDate(contractLower)} to ${getSpyGlassDate(contractUpper)}.
            However, the selected pricing date (${getSpyGlassDate(quotePricingDate)}) falls outside this valid range.`,
    life: 10000
  });
};

const selectWellAddress = (event: AutoCompleteItemSelectEvent) => {
  advancedSearch.value.skPlanningOrder = null;

  if (quote?.value?.id) {
    quote.value.sk_planning_order = null;
  }

  const well = event.value.well;
  const address = event.value.address;
  const customer = event.value.customer;

  const erp_address_id = address?.id;
  const erp_address_name = address?.name;
  const erp_full_address = address?.full_address;
  const erp_well_id = well?.id;
  const erp_well_name = well?.name;
  const erp_well_uwi = well?.uwi;
  const erp_customer_number = customer?.id;
  const erp_customer_name = customer?.name;
  const erp_well_region = address?.region?.code;
  const erp_well_country = address?.region?.country?.code;

  const newQuoteData: Partial<QuoteType> = {
    erp_address_id,
    erp_address_name,
    erp_full_address,
    erp_well_id,
    erp_well_name,
    erp_well_uwi,
    erp_customer_number,
    erp_customer_name,
    erp_well_region,
    erp_well_country
  };

  advancedSearch.value.wellAddressSearch = {
    customerSearch: newQuoteData?.erp_customer_name,
    customer: {
      name: newQuoteData?.erp_customer_name,
      id: newQuoteData.erp_customer_number
    },
    well: {
      name: newQuoteData?.erp_well_name,
      uwi: newQuoteData?.erp_well_uwi,
      id: newQuoteData.erp_well_id
    },
    address: {
      id: newQuoteData?.erp_address_id,
      name: newQuoteData?.erp_address_name,
      full_address: newQuoteData?.erp_full_address,
      region: {
        code: newQuoteData?.erp_well_region,
        country: { code: newQuoteData?.erp_well_country }
      }
    }
  };

  const shouldUpdatePricing =
    advancedSearch.value.wellAddressSearch?.address?.region?.country !==
    newQuoteData.erp_well_country;

  return nextTick()
    .then(() => fetchPlanningOrder())
    .then(resp => {
      // TODO: uncomment the following if the bandaid fix in EditQuote is removed
      // advancedSearch.value.wellAddressSearch = {
      //   customerSearch: newQuoteData?.erp_customer_name,
      //   customer: {
      //     name: newQuoteData?.erp_customer_name,
      //     id: newQuoteData.erp_customer_number
      //   },
      //   well: {
      //     name: newQuoteData?.erp_well_name,
      //     uwi: newQuoteData?.erp_well_uwi,
      //     id: newQuoteData.erp_well_id
      //   },
      //   address: {
      //     id: newQuoteData?.erp_address_id,
      //     name: newQuoteData?.erp_address_name,
      //     full_address: newQuoteData?.erp_full_address,
      //     region: {
      //       code: newQuoteData?.erp_well_region,
      //       country: { code: newQuoteData?.erp_well_country }
      //     }
      //   }
      // };
      const plo_resp = pickQuotePlanningOrder(resp?.data?.value?.getSKPlanningOrder)
      const planning_order = plo_resp?.id || null;
      const currency = plo_resp?.currency || null;
      const nwa_id = plo_resp?.nwa_id || null;
      const plant_id = plo_resp?.plant_erp_id || null;
      const plant_name = plo_resp?.plant_name || null;
      const price_list_name = plo_resp?.price_list_name || null;
      const price_list_number = plo_resp?.price_list_number || null;
      const contract = plo_resp?.contract || null;

      if (planning_order) {
        advancedSearch.value.skPlanningOrder = planning_order;
      }

      if (contract) {
        advancedSearch.value.contractSearch = {
          number: contract,
          contractSearchString: contract
        };
      }

      if (price_list_name && price_list_number) {
        advancedSearch.value.priceListSearch = {
          priceListSearchString: price_list_name,
          name: price_list_name,
          number: price_list_number
        };
      }

      if (nwa_id) {
        // The planning order's NWA name is the one stored on an old SK job;
        // resolve the id against the canonical NWA (SK-5231 / AL Name).
        resolveNwa(nwa_id).then(nwaResolution => {
          const { erp_nwa_id, erp_nwa_name } = getQuoteNwaFields(plo_resp, nwaResolution);
          if (erp_nwa_id && erp_nwa_name) {
            advancedSearch.value.nwaSearch = {
              nwaSearchString: erp_nwa_name,
              name: erp_nwa_name,
              id: erp_nwa_id
            };
          }
        });
      }

      if (currency) {
        advancedSearch.value.currency = {
          currencySearchString: currency,
          code: currency
        };
      }

      if (plant_name && plant_id) {
        advancedSearch.value.salesDistrictSearch = {
          plantSearch: plant_name,
          name: plant_name,
          id: plant_id
        };
      }
    })
    .then(() => {
      if (shouldUpdatePricing) {
        updatePricing();
      }
    })
    .catch(err => {
      console.error(err);
      throw new Error(err);
    });
};

// Well Address Data Fetching
const filteredWellAddresses = ref<Array<SkWellAddress>>([]);
const filteredWellAddressOptions = ref<Array<SkWellAddress>>([]);
const useShipTo = ref<boolean>(false);
const deriveUseShipToFromSelection = () => {
  const customerId = advancedSearch.value.wellAddressSearch?.customer?.id;
  const wellId = advancedSearch.value.wellAddressSearch?.well?.id;
  return Boolean(customerId && !wellId);
};
const syncUseShipToWithSelection = () => {
  useShipTo.value = deriveUseShipToFromSelection();
};

watch(
  () => [
    advancedSearch.value.wellAddressSearch?.customer?.id,
    advancedSearch.value.wellAddressSearch?.well?.id
  ],
  () => {
    // Keep the checkbox aligned with loaded/selected quote data.
    syncUseShipToWithSelection();
  },
  { immediate: true }
);

const { fetching: fetchingWellAddresses, executeQuery: fetchWellAddresses } =
  useSkWellAddressesQuery({
    pause: true,
    requestPolicy: "network-only",
    variables: computed(() => {
      const queryParams: WellAddressSearchParams = {
        deleted: "False",
        expand: "well,address.region.country,customer",
        ordering: "name",
        well_search: advancedSearch?.value?.wellAddressSearch?.customerSearch
      };

      return {
        summitQueryString: createQueryString(queryParams)
      };
    })
  });

const completeSearchWell = () => {
  return Promise.resolve()
    .then(() => Promise.allSettled([fetchWellAddresses(), fetchShipTos()]))
    .then(([wellResp, shipToResp]) => {
      const wellResults = wellResp.status === "fulfilled"
        ? cleanNull(wellResp.value?.data?.value?.getSKWellAddresses || [])
        : [];

      const shipToResults = shipToResp.status === "fulfilled"
        ? cleanNull(shipToResp.value?.data?.value?.getSKWellAddresses || [])
        : [];

      filteredWellAddresses.value = wellResults;
      filteredShipTos.value = shipToResults;

      // Show one combined list and dedupe rows returned by both searches.
      const combinedResults = [...wellResults, ...shipToResults];
      const deduped = new Map<string, SkWellAddress>();
      combinedResults.forEach(item => {
        const key = `${item?.well?.id || 'no-well'}::${item?.address?.id || 'no-address'}::${item?.customer?.id || 'no-customer'}`;
        if (!deduped.has(key)) {
          deduped.set(key, item);
        }
      });
      filteredWellAddressOptions.value = [...deduped.values()];
    });
};

const resetSearchWell = () => {
  advancedSearch.value.wellAddressSearch.customerSearch =
    advancedSearch.value.wellAddressSearch.customer.name;
};

// Ship To Data Fetching (same sk well address query, but different params - could probably combine with well addresses, but the reactive types will be different)
const filteredShipTos = ref<Array<SkWellAddress>>([]);
const { fetching: fetchingShipTos, executeQuery: fetchShipTos } =
  useSkWellAddressesQuery({
    pause: true,
    requestPolicy: "network-only",
    variables: computed(() => {
      const queryParams: WellAddressSearchParams  = {
        address_search:
          advancedSearch?.value?.wellAddressSearch?.customerSearch,
        expand: "well,address.region.country,customer",
        include_null_addresses: "False",
      };

      return {
        summitQueryString: createQueryString(queryParams)
      };
    })
  });

// Price List Data Fetching
const filteredPriceLists = ref<Array<SkPriceList>>([]);
const { fetching: fetchingPriceLists, executeQuery: fetchPriceLists } =
  useSkPriceListsQuery({
    pause: true,
    requestPolicy: "network-only",
    variables: computed(() => {
      const queryParams: PriceListSearchParams = {
        active: "True",
        deleted: "False",
        ordering: "name",
        name__icontains:
          advancedSearch.value.priceListSearch.priceListSearchString
      };

      return {
        summitQueryString: createQueryString(queryParams)
      };
    })
  });

const filteredJobTypes = [
  {comment: 'Sale', value: SgqJobTypes.SALE},
  {comment: 'Rental (Well Test)', value: SgqJobTypes.RENTAL}
];

const filteredQuoteTypes = [
  {comment: 'Installation',value: SgqQuoteTypes.INSTALLATION},
  {comment: 'Monitoring',value: SgqQuoteTypes.MONITORING}
]

const selectPriceList = () => {
  const searchVal = advancedSearch.value.priceListSearch.priceListSearchString;
  const shouldUpdatePricing =
    searchVal.name !== advancedSearch.value.priceListSearch.name;
  advancedSearch.value.priceListSearch.number = searchVal.number;
  advancedSearch.value.priceListSearch.name = searchVal.name;
  advancedSearch.value.priceListSearch.priceListSearchString = searchVal.name;
  if (shouldUpdatePricing) {
    updatePricing()
  }
};

const completeSearchPriceList = () => {
  return Promise.resolve()
    .then(() => fetchPriceLists())
    .then(resp => {
      filteredPriceLists.value = cleanNull(resp?.data?.value?.getSKPriceLists || []);
    });
};

const resetPriceList = () => {
  advancedSearch.value.priceListSearch.priceListSearchString =
    advancedSearch.value.priceListSearch.name || ""; // <--- prevents undefined as string
};

const { executeQuery: fetchCurrencies, fetching: fetchingCurrencies } =
  useGetSkCurrenciesQuery({
    pause: true,
    requestPolicy: "network-only",
    variables: computed(() => {
      const currency = advancedSearch.value?.currency?.currencySearchString || "";
      const queryParams: CurrencySearchParams = {
        page_size: "all",
        active: "True",
        deleted: "False",
        code__icontains: currency
      }

      return {
        summitQueryString: createQueryString(queryParams)
      };
    })
  });

// Currency data fetching
const filteredCurrencies = ref<Array<SkCurrency>>([]);
const completeSearchCurrency = () => {
  return Promise.resolve()
    .then(() => fetchCurrencies())
    .then(resp => {
      const currencies = cleanNull(resp?.data?.value?.getSKCurrencies || []);

      currencies.sort((a, b) => {
        if (a.code === "USD") return -1;
        if (b.code === "USD") return 1;
        if (a.code === "CAD" && b.code !== "USD") return -1;
        if (b.code === "CAD" && a.code !== "USD") return 1;
        return 0;
      });

      filteredCurrencies.value = currencies;
    });
};

const currencySelect = (evt: AutoCompleteItemSelectEvent) => {
  advancedSearch.value.currency.currencySearchString = evt.value.code;
  advancedSearch.value.currency.code = evt.value.code;
};

const resetSearchCurrency = () => {
  advancedSearch.value.currency.currencySearchString =
    advancedSearch.value.currency.code || advancedSearch.value.currency.name;
};

// User Data Fetching
const filteredUsers = ref<Array<UsersFieldsFragment>>([]);
const { executeQuery: fetchUsers, fetching: fetchingUsers } = useUsersQuery({
  pause: true,
  requestPolicy: "network-only",
  variables: computed(() => {
    return {
      limit: 20,
      offset: 0,
      distinct_on: [Users_Select_Column.DisplayName], // Edge case: duplicate users. Just pick any dupe user. Their HAL IDs are identical.
      where: {
        display_name: {
          _ilike: `%${autoVal(advancedSearch.value.userSearch.userSearchString, Users_Select_Column.DisplayName)}%`
        },
        hal_identifier: {
          _is_null: false // <--- filters out dupe users with null HAL IDs (SK needs HAL ID for job create)
        }
      }
    };
  })
});

const handleProposedStartDateCalendarBlur = () => {
  // "overlayVisible" is not an exposed property during runtime, so casting to any
  (proposedStartDateCalendarRef as any).value.overlayVisible = false;
};

const handlePricingDateCalendarBlur = () => {
  // "overlayVisible" is not an exposed property during runtime, so casting to any
  (pricingDateCalendarRef as any).value.overlayVisible = false;
};

const completeSearchUser = () => {
  return Promise.resolve()
    .then(() => fetchUsers())
    .then(resp => {
      filteredUsers.value = cleanNull(resp?.data?.value?.users || []);
    });
};

const selectUserSearch = () => {
  const searchVal = advancedSearch.value.userSearch.userSearchString;
  advancedSearch.value.userSearch.display_name = searchVal.display_name;
  advancedSearch.value.userSearch.id = searchVal.id;
  advancedSearch.value.userSearch.userSearchString = searchVal.display_name;
};

const resetUserSearch = () => {
  advancedSearch.value.userSearch.userSearchString =
    advancedSearch.value.userSearch.display_name;
};

const pricingContext = computed(() => getQuotePricingContext(advancedSearch.value, quote?.value));
const pricingDataComplete = computed(() => pricingContext.value.missing.length === 0);
const jobTypeDisabledReason = computed(() => {
  if (quoteIsWonOrRejected.value || loading.value || pricingDataComplete.value) {
    return "";
  }
  return `Select ${pricingContext.value.missing.join(", ")} first.`;
});

const { executeQuery: fetchRentalMonthlyMaterial } =
  useSkMaterialsQuery({
    requestPolicy: "network-only",
    pause: !pricingDataComplete.value,
    variables: computed(() => {
      if (advancedSearch.value.skJobType) {
        return {
          summitQueryString: createQueryString({
            sk_erp_entity_id: JobTypeServiceMaterialNumbers.MONTHLY,
            country: pricingContext.value.country,
            deleted: "False",
            exclude_trade_in: "True",
            expand: "pricing",
            ordering: "description,number",
            price_list: pricingContext.value.priceListNumber,
            pricing_date: pricingContext.value.pricingDate
          })
        }
      }
      return {}
    })
  });

const { executeQuery: fetchRentalDailyMaterial } =
  useSkMaterialsQuery({
    requestPolicy: "network-only",
    pause: !pricingDataComplete.value,
    variables: computed(() => {
      if (advancedSearch.value.skJobType) {
        return {
          summitQueryString: createQueryString({
            sk_erp_entity_id: JobTypeServiceMaterialNumbers.DAILY,
            country: pricingContext.value.country,
            deleted: "False",
            exclude_trade_in: "True",
            expand: "pricing",
            ordering: "description,number",
            price_list: pricingContext.value.priceListNumber,
            pricing_date: pricingContext.value.pricingDate
          })
        }
      }
      return {}
    })
  });

const { executeQuery: fetchRentalMonitoringMaterial } =
  useSkMaterialsQuery({
    requestPolicy: "network-only",
    pause: !pricingDataComplete.value,
    variables: computed(() => {
      if (advancedSearch.value.skJobType) {
        return {
          summitQueryString: createQueryString({
            sk_erp_entity_id: JobTypeServiceMaterialNumbers.RENTAL_MONITORING_FEE,
            country: pricingContext.value.country,
            deleted: "False",
            exclude_trade_in: "True",
            expand: "pricing",
            ordering: "description,number",
            price_list: pricingContext.value.priceListNumber,
            pricing_date: pricingContext.value.pricingDate
          })
        }
      }
      return {}
    })
  });

const { executeQuery: fetchDirectSaleMonitoringMaterial } =
  useSkMaterialsQuery({
    requestPolicy: "network-only",
    pause: !pricingDataComplete.value,
    variables: computed(() => {
      if (advancedSearch.value.skJobType) {
        return {
          summitQueryString: createQueryString({
            sk_erp_entity_id: JobTypeServiceMaterialNumbers.DIRECT_SALE_MONITORING_FEE,
            country: pricingContext.value.country,
            deleted: "False",
            exclude_trade_in: "True",
            expand: "pricing",
            ordering: "description,number",
            price_list: pricingContext.value.priceListNumber,
            pricing_date: pricingContext.value.pricingDate
          })
        }
      }
      return {}
    })
  });

let erpMonthlyMaterial: CanBeMissing<SkMaterial>;
let erpDailyMaterial: CanBeMissing<SkMaterial>;
let erpRentalMonitoringMaterial: CanBeMissing<SkMaterial>;
let erpDirectSaleMonitoringMaterial: CanBeMissing<SkMaterial>;
let qlisToAdd: Partial<QuoteLineItemType>[] = [];
let qlisToRemove: GqlQli[] = [];
let qlisToUpdate: GqlQli[] = [];

/**
 * Process service charges based on user-selected 'Job Type' and 'Quote Type'.
 *
 * We either add or remove line items that are essentially
 * SK service charges for eventual job creation.
 *
 * Add parameters and or return statements if needs change.
 */
const processServiceCharges = () => {

  const _updateQuoteWithServiceCharges = () => {
    const quoteObj = formatQuoteHeaderForSave(quote?.value, advancedSearch.value)
    const updateLineItems = qlisToUpdate.concat(qlisToRemove).filter(Boolean)
    const createLineItems = qlisToAdd
      .filter(lineItem => !lineItem?.id)
      .map(item => formatQuoteLineItemForSave(item, quote?.value?.id));

    toggleSaving(true);
    return updateQuote({
      id: quote?.value?.id,
      object: quoteObj,
      update_line_items: updateLineItems,
      create_line_items: createLineItems
    })
    .then((resp) => {
      props.refetchQuote();
    })
    .finally(() => {
      [qlisToUpdate, qlisToRemove, qlisToAdd] = [[], [], []];
      toggleSaving(false);
    })
  }

  const _setQlisToUpdateSuborders = () => {
    // Call this after "removing" line items to prevent race condition bugs
    const removedIds = qlisToRemove.map((gql_qli) => { return gql_qli?.where?.id._eq })

    const qlisRemainingReevaluated = structuredClone(toRaw(quote?.value?.quote_line_items || []))
      .filter(item => !removedIds.includes(item?.id))
      .map(qli => formatQuoteLineItemForSave(qli, quote?.value?.id))
      .map((qli, index) => {
        // Return a GQL QLI object *with* a re-evaluated sub_order:
        return {
          _set: { ...qli, sub_order: index + 1 },
          where: {
            id: { _eq: qli.id }
          }
        };
      });

    qlisToUpdate.push(...qlisRemainingReevaluated);
  }

  // Dev note: I'm checking refs directly as to avoid race conditions with quote object saving.
  const isSaleInstall = sgqJobType.value === SgqJobTypes.SALE && sgqQuoteType.value === SgqQuoteTypes.INSTALLATION;
  const isSaleMonitoring = sgqJobType.value === SgqJobTypes.SALE && sgqQuoteType.value === SgqQuoteTypes.MONITORING;
  const isRentalInstall = sgqJobType.value === SgqJobTypes.RENTAL && sgqQuoteType.value === SgqQuoteTypes.INSTALLATION;
  const isRentalMonitoring = sgqJobType.value === SgqJobTypes.RENTAL && sgqQuoteType.value === SgqQuoteTypes.MONITORING;

  if (isSaleInstall) { // Sale/trade - SESP DIRECT SALE BOM - INSTALLATION
    nextTick()
    .then(() => fetchDirectSaleMonitoringMaterial())
    .then(removeRentalFeeLineItems)
    .then(removeRentalMonitoringLineItem)
    .then(removeDirectSaleMonitoringLineItem)
    .then(_setQlisToUpdateSuborders)
    .then(_updateQuoteWithServiceCharges);
  } else if (isSaleMonitoring) { // Sale/trade - SESP DIRECT SALE BOM - MONITORING FEE
    nextTick()
    .then(() => fetchDirectSaleMonitoringMaterial())
    .then(resp => {
      erpDirectSaleMonitoringMaterial = resp?.data?.value?.getSKMaterials?.[0];
    })
    .then(removeRentalMonitoringLineItem)
    .then(removeRentalFeeLineItems)
    .then(_setQlisToUpdateSuborders)
    .then(addDirectSaleMonitoringLineItem)
    .then(_updateQuoteWithServiceCharges);
  } else if (isRentalInstall) { // Well Test - SESP RENTAL BOM - INSTALLATION
    Promise.all([
      nextTick()
      .then(() => fetchRentalDailyMaterial())
      .then(resp => {
        erpDailyMaterial = resp.data.value?.getSKMaterials?.[0];
      }),
      nextTick()
      .then(() => fetchRentalMonthlyMaterial())
      .then(resp => {
        erpMonthlyMaterial = resp.data.value?.getSKMaterials?.[0];
      }),
    ])
    .then(removeDirectSaleMonitoringLineItem)
    .then(removeRentalMonitoringLineItem)
    .then(_setQlisToUpdateSuborders)
    .then(addRentalFeeLineItems)
    .then(_updateQuoteWithServiceCharges);
  } else if (isRentalMonitoring) { // Well Test - SESP RENTAL BOM - MONITORING FEE
    Promise.all([
      nextTick()
      .then(() => fetchRentalDailyMaterial())
      .then(resp => {
        erpDailyMaterial = resp.data.value?.getSKMaterials?.[0];
      }),
      nextTick()
      .then(() => fetchRentalMonthlyMaterial())
      .then(resp => {
        erpMonthlyMaterial = resp.data.value?.getSKMaterials?.[0];
      }),
      nextTick()
      .then(() => fetchRentalMonitoringMaterial())
      .then(resp => {
        erpRentalMonitoringMaterial = resp.data.value?.getSKMaterials?.[0];
      })
    ])
    .then(removeDirectSaleMonitoringLineItem)
    .then(_setQlisToUpdateSuborders)
    .then(addRentalMonitoringLineItem)
    .then(addRentalFeeLineItems)
    .then(_updateQuoteWithServiceCharges);
  }
};

const addRentalFeeLineItems = () => {
  const date = new Date();
  const pricingDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

  const monthly = quote?.value?.quote_line_items.filter(item => {
    return item.erp_material_number === String(JobTypeServiceMaterialNumbers.MONTHLY);
  })[0];
  const daily = quote?.value?.quote_line_items.filter(item => {
    return item.erp_material_number === String(JobTypeServiceMaterialNumbers.DAILY);
  })[0];

  if (monthly === undefined) {
    qlisToAdd.push({
      quote_id: quote?.value?.id,
      category: Category.Service,
      subcategory: SubCategory.Reusable,
      quantity: 1,
      parent_order: parentOrder[LineItemType.Uncategorized],
      note: "",
      pricing_date: pricingDate,
      credit: 0,
      source: Source.User,
      erp_price: erpMonthlyMaterial?.pricing?.price || 0,
      price_override: 0,
      erp_product_hierarchy: erpMonthlyMaterial?.prod_hierarchy || "",
      erp_uom: erpMonthlyMaterial?.base_uom || "ea",
      margin: 0,
      line_item_type: LineItemType.Uncategorized,
      erp_material_number: erpMonthlyMaterial?.number || String(JobTypeServiceMaterialNumbers.MONTHLY),
      erp_material_short_description: erpMonthlyMaterial?.description || JobTypeServiceMaterialShortDesc.MONTHLY,
      erp_material_long_description: erpMonthlyMaterial?.long_description || JobTypeServiceMaterialLongDesc.MONTHLY,
      sub_order: getAddedMaterialSubOrder(LineItemType.Uncategorized, quote?.value) + qlisToAdd.length - qlisToRemove.length
    });
  }

  if (daily === undefined) {
    qlisToAdd.push({
      quote_id: quote?.value?.id,
      category: Category.Service,
      subcategory: SubCategory.Reusable,
      quantity: 1,
      parent_order: parentOrder[LineItemType.Uncategorized],
      note: "",
      pricing_date: pricingDate,
      credit: 0,
      source: Source.User,
      erp_price: erpDailyMaterial?.pricing?.price || 0,
      price_override: 0,
      erp_product_hierarchy: erpDailyMaterial?.prod_hierarchy || "",
      erp_uom: erpDailyMaterial?.base_uom || "ea",
      margin: 0,
      line_item_type: LineItemType.Uncategorized,
      erp_material_number: erpDailyMaterial?.number || String(JobTypeServiceMaterialNumbers.DAILY),
      erp_material_short_description: erpDailyMaterial?.description || JobTypeServiceMaterialShortDesc.DAILY,
      erp_material_long_description: erpDailyMaterial?.long_description || JobTypeServiceMaterialLongDesc.DAILY,
      sub_order: getAddedMaterialSubOrder(LineItemType.Uncategorized, quote?.value) + qlisToAdd.length - qlisToRemove.length
    });
  }
};

const removeRentalFeeLineItems = () => {
  const monthly = quote?.value?.quote_line_items.filter(item => {
    return item.erp_material_number === String(JobTypeServiceMaterialNumbers.MONTHLY);
  })[0];
  const daily = quote?.value?.quote_line_items.filter(item => {
    return item.erp_material_number === String(JobTypeServiceMaterialNumbers.DAILY);
  })[0];

  // (2/2) Declare the items to be removed, if applicable:
  if (daily) {
    qlisToRemove.push({
      _set: { deleted_at: "now()" },
      where: {
        id: { _eq: daily.id }
      }
    });
  }
  if (monthly) {
    qlisToRemove.push({
      _set: { deleted_at: "now()" },
      where: {
        id: { _eq: monthly.id }
      }
    });
  }
};

const addDirectSaleMonitoringLineItem = () => {
  const date = new Date();
  const pricingDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

  const direct = quote?.value?.quote_line_items.filter(item => {
    return item.erp_material_number === String(JobTypeServiceMaterialNumbers.DIRECT_SALE_MONITORING_FEE);
  })[0];

  if (direct === undefined) {
    qlisToAdd.push({
      quote_id: quote?.value?.id,
      category: Category.Service,
      subcategory: SubCategory.Reusable,
      quantity: 1,
      parent_order: parentOrder[LineItemType.Uncategorized],
      note: "",
      pricing_date: pricingDate,
      credit: 0,
      source: Source.User,
      erp_price: erpDirectSaleMonitoringMaterial?.pricing?.price || 0,
      price_override: 0,
      erp_product_hierarchy: erpDirectSaleMonitoringMaterial?.prod_hierarchy || "",
      erp_uom: erpDirectSaleMonitoringMaterial?.base_uom || "ea",
      margin: 0,
      line_item_type: LineItemType.Uncategorized,
      erp_material_number: erpDirectSaleMonitoringMaterial?.number || String(JobTypeServiceMaterialNumbers.DIRECT_SALE_MONITORING_FEE),
      erp_material_short_description: erpDirectSaleMonitoringMaterial?.description || JobTypeServiceMaterialShortDesc.DIRECT_SALE_MONITORING_FEE,
      erp_material_long_description: erpDirectSaleMonitoringMaterial?.long_description || JobTypeServiceMaterialLongDesc.DIRECT_SALE_MONITORING_FEE,
      sub_order: getAddedMaterialSubOrder(LineItemType.Uncategorized, quote?.value) + qlisToAdd.length - qlisToRemove.length
    });
  }
};

const removeDirectSaleMonitoringLineItem = () => {
  const direct = quote?.value?.quote_line_items.filter(item => {
    return item.erp_material_number === String(JobTypeServiceMaterialNumbers.DIRECT_SALE_MONITORING_FEE);
  })[0];

  if (direct) {
    qlisToRemove.push({
      _set: { deleted_at: "now()" },
      where: {
        id: { _eq: direct.id }
      }
    });
  }
};

const addRentalMonitoringLineItem = () => {
  const date = new Date();
  const pricingDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

  const rental = quote?.value?.quote_line_items.filter(item => {
    return item.erp_material_number === String(JobTypeServiceMaterialNumbers.RENTAL_MONITORING_FEE);
  })[0];

  if (rental === undefined) {
    qlisToAdd.push({
      quote_id: quote?.value?.id,
      category: Category.Service,
      subcategory: SubCategory.Reusable,
      quantity: 1,
      parent_order: parentOrder[LineItemType.Uncategorized],
      note: "",
      pricing_date: pricingDate,
      credit: 0,
      source: Source.User,
      erp_price: erpRentalMonitoringMaterial?.pricing?.price || 0,
      price_override: 0,
      erp_product_hierarchy: erpRentalMonitoringMaterial?.prod_hierarchy || "",
      erp_uom: erpRentalMonitoringMaterial?.base_uom || "ea",
      margin: 0,
      line_item_type: LineItemType.Uncategorized,
      erp_material_number: erpRentalMonitoringMaterial?.number || String(JobTypeServiceMaterialNumbers.RENTAL_MONITORING_FEE),
      erp_material_short_description: erpRentalMonitoringMaterial?.description || JobTypeServiceMaterialShortDesc.RENTAL_MONITORING_FEE,
      erp_material_long_description: erpRentalMonitoringMaterial?.long_description || JobTypeServiceMaterialLongDesc.RENTAL_MONITORING_FEE,
      sub_order: getAddedMaterialSubOrder(LineItemType.Uncategorized, quote?.value) + qlisToAdd.length - qlisToRemove.length
    });
  }
};

const removeRentalMonitoringLineItem = () => {
  const rental = quote?.value?.quote_line_items.filter(item => {
    return item.erp_material_number === String(JobTypeServiceMaterialNumbers.RENTAL_MONITORING_FEE);
  })[0];

  if (rental) {
    qlisToRemove.push({
      _set: { deleted_at: "now()" },
      where: {
        id: { _eq: rental.id }
      }
    });
  }
};

const deleteDraftClicked = (evt: MouseEvent) => {
  if (!quote?.value?.id) {
    // must exist a quote id in order to delete one
    return;
  }
  return updateQuote({
    id: quote?.value?.id,
    object: { deleted_at: "now()" },
    create_line_items: [],
    update_line_items: []
  })
  .then(resp => {
    const routeData = router.push({
      name: "ListQuotes",
      params: {
        quoteId: quote?.value?.id
      },
      query: {
        page: 1
      }
    });
    // window.open(routeData.href + "?page=1", "_blank");
  });
};

const { executeQuery: fetchJobs } = useSkJobsQuery({
  pause: !quote?.value?.sk_job_id,
  requestPolicy: "network-only",
  variables: computed(() => {
    const queryParams: JobSearchParams = {
      sk_job_id: quote?.value?.sk_job_id,
      deleted: "False"
    }

    return {
      summitQueryString: createQueryString(queryParams)
    };
  })
});

const sk_job_url = computed(() => {
  let domain = '';
  if (window.config.ENV === "development") {
    domain = "http://localhost:8000"
  }
  else {
    domain = window.config.SUMMIT_KNOWLEDGE_URL
  }
  return `${domain}/#/job/${quote?.value?.sk_job_id}`;
})

const openJob = (event: MouseEvent) => {
  // Dev note: if we want to open with middle mouse click, use @mousedown event
  // and check for event.button's 0 and 1 (left and middle mouse buttons)
  const selection = window.getSelection();
  const highlightingForCopyPaste = (selection && selection.toString().length > 0)
  if (highlightingForCopyPaste) {
    event.stopPropagation();
    event.preventDefault();
  }
  else {
    window.open(sk_job_url.value, '_blank');
  }
};

const toggleSaving = (isSaving: boolean) => {
  emit("toggle", isSaving);
}

// A watcher to ensure the correct SK Job Type is set
watch([sgqJobType, sgqQuoteType], ([newJobType, newQuoteType]) => {
  const isBothRequiredOptionsAreSelected = newJobType && newQuoteType;
  if (isBothRequiredOptionsAreSelected) {
    const isSaleInstall = newJobType === SgqJobTypes.SALE && newQuoteType === SgqQuoteTypes.INSTALLATION;
    const isSaleMonitoring = newJobType === SgqJobTypes.SALE && newQuoteType === SgqQuoteTypes.MONITORING;
    const isRentalInstall = newJobType === SgqJobTypes.RENTAL && newQuoteType === SgqQuoteTypes.INSTALLATION;
    const isRentalMonitoring = newJobType === SgqJobTypes.RENTAL && newQuoteType === SgqQuoteTypes.MONITORING;
    if (isSaleInstall) {
      advancedSearch.value.skJobType = SKJobType.Spyglass_1126619;
    }
    else if (isSaleMonitoring) {
      advancedSearch.value.skJobType = SKJobType.Spyglass_1092014;
    }
    else if (isRentalInstall) {
      advancedSearch.value.skJobType = SKJobType.Spyglass_1092000;
    }
    else if (isRentalMonitoring) {
      advancedSearch.value.skJobType = SKJobType.Spyglass_1092002;
    }
  }
  else {
    // Reset SK Job Type if either is empty
    advancedSearch.value.skJobType = null;
  }
});

const restoreJobTypeAndQuoteType = () => {
  const isSaleInstall = quote?.value?.sk_job_type == SKJobType.Spyglass_1126619;
  const isSaleMonitor = quote?.value?.sk_job_type == SKJobType.Spyglass_1092014;
  const isRentalMonitor = quote?.value?.sk_job_type == SKJobType.Spyglass_1092002;
  const isRentalInstall = quote?.value?.sk_job_type == SKJobType.Spyglass_1092000;
  if (isSaleInstall) {
    sgqJobType.value = SgqJobTypes.SALE;
    sgqQuoteType.value = SgqQuoteTypes.INSTALLATION;
  }
  else if (isSaleMonitor) {
    sgqJobType.value = SgqJobTypes.SALE;
    sgqQuoteType.value = SgqQuoteTypes.MONITORING;
  }
  else if (isRentalInstall) {
    sgqJobType.value = SgqJobTypes.RENTAL;
    sgqQuoteType.value = SgqQuoteTypes.INSTALLATION;
  }
  else if (isRentalMonitor) {
    sgqJobType.value = SgqJobTypes.RENTAL;
    sgqQuoteType.value = SgqQuoteTypes.MONITORING;
  }
  else {
    sgqJobType.value = "";
    sgqQuoteType.value = "";
  }
}

onMounted(() => { // Dev note: this is equivalent to a watchOnce - may change later and test
  watch(quote, _ => {
    if (quote.value != null) {
      loading.value = false;
      if (quote.value.sk_job_id && !quote.value.sk_job_number) {
        fetchJobs().then((resp) => {
          const skJob = resp?.data?.value?.getSKJobs?.[0];
          advancedSearch.value.sk_job_number = skJob?.number;
        })
      }
      restoreJobTypeAndQuoteType();
    }
  });

  if (quote?.value?.erp_contract_number) {
    completeSearchContract()
      .finally(() => {
        // Force trigger selectContract for functional parity
        const mockSelectEvent: Partial<AutoCompleteItemSelectEvent> = {
          value: {
            number: String(quote?.value?.erp_contract_number)
          }
        };
        selectContract(mockSelectEvent);
    });
  }
});
</script>

<style lang="scss" scoped>
/* TODO: confirm alternatives to :deep */
.line-divider {
  // TODO: just learning there is an already existing line divider here:
  // scss/theme-base/components/panel/_divider.scss
  // might want to remove this my solution in favor of Spyglass's for consistency
  margin: 0 2vw;
  width: 1px;
  background-color: var(--surface-500);
  @media only screen and (max-width: 768px) {
    margin: 2vw 0;
    width: 100%;
    height: 1px;
  }
}

.grid-align-override {
  /** The spyglass grid attemps to balance grid content vertically if there is
  content next to said grid, thanks to align-content. We need everything from
  the grid class except this extra vertical white space, so override it*/
  align-content: flex-start;
}

.well-or-address-label {
  font-weight: bold;
}


:deep {
  span.p-dropdown-label.p-inputtext {
    /* "Version" and "SK Job Type" dropdowns */
    height: 49.98px;
    padding-left: 0.5rem;
    font-family: arial;
  }

  .p-calendar .p-button,
  .p-autocomplete .p-button {
    min-width: 20px;
  }

  .fixed-inner-label input:not(.internal-notes-box),
  .fixed-inner-label textarea,
  .fixed-inner-label .p-inputnumber > input,
  .fixed-inner-label select {
    /* All dropdowns (to match Spyglass styling) */
    padding: 1.4rem 1rem 0.1rem 0.5rem;
    font-size: 16px;
    font-family: arial;
  }

  // TODO: invesigate alternatives to these bandaid fixes
  // (remove these and you'll elements being selectable that should not be)
  .fixed-inner-label {
    white-space: nowrap; // prevents label wrapping if too long
    text-indent: 0; // prevents label wrapping if too long
    user-select: none; // fixes outside of label from being selectable/highlightable

    label {
      // Fixed inner label behavior
      user-select: none;
      pointer-events: none;
    }
  }

  .internal-notes-field {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  textarea.p-inputtextarea.p-inputtext.p-component.internal-notes-box {
    width: 100%;
    padding-left: 0.9rem;
    padding-right: 0.9rem;
    resize: none;
    font-size: 16px;
    font-family: arial;
  }

  .fixed-inner-label.internal-notes-label {
    label {
      font-weight: bold;
      color: var(--surface-70);
      margin-left: 0px;
    }
  }

  .no-select-cursor {
    user-select: none;
  }

  .well-search-box > input.p-autocomplete-input.p-inputtext.p-component {
    width: 100%;
  }

  .ship-to-checkbox {
    margin-top: 14px !important;
  }

  .ship-to-input {
    @media screen and (max-width: 991px) {
      padding-bottom: 0px;
    }
  }

  .ship-to-box {
    @media screen and (max-width: 991px) {
      width: 110px;
      margin-left: 8px;
      margin-top: 0px;
    }
    @media screen and (min-width: 991px) {
    }
    height: 48px;
    box-shadow: var(--shadow-main);
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    padding-top: 0px;
    margin-top: 9px;
    z-index: 1;
    background: var(--surface-25);

    label {
      padding-left: 18px;
      padding-top: 6px;
      z-index: -1;
      color: var(--gray-900);
      font-size: 16px;
    }
  }

  .loading-spinner {
    border: 2px solid $spyglass-blue;
    border-top: 2px solid var(--surface-400);
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 2s linear infinite;
    display: inline-block;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}

.left-vertical-container button.quote-button.p-button-info {
  // lvc not defined in here?
  margin: 0.5rem;
}

/* Deleted Quote CSS */
.delete-draft-button {
  width: auto;
  color: white;
  background-color: #ff4e4e;
}

#deletedStamp {
  background-color: #ff4e4e;
  height: 4rem;
  z-index: 9;
  margin-bottom: 2rem;
}

.deleted-label {
  text-align: center;
  color: black;
  z-index: 10;
  font-size: 20px;
  line-height: 4rem; /* match height from parent - center vertically */
}
/* End Deleted Quote CSS */

/* Job Number box CSS */
.job-number-input {
  box-sizing: content-box;
  width: 100%;
  color: var(--info-500);
}

.job-number-input:hover {
  cursor: pointer;
}
/* End Job Number box CSS */

.job-row-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  margin-bottom: 1rem;
}
.button-group {
  display: flex;
  align-items: flex-end;
  gap: 1rem;
}
.uniform-height {
  height: 48px !important;
  min-height: 48px !important;
  font-size: 16px;
  box-sizing: border-box;
}
@media (max-width: 900px) {
  .job-row-wrap {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
  }
  .button-group {
    width: 100%;
    gap: 0.5rem;
  }
}
.expired-badge {
  background: #ff4e4e;
  color: white;
  border-radius: 4px;
  padding: 2px 6px;
  margin-left: 8px;
  font-size: 0.85em;
  font-weight: bold;
}
.contract-option-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>
